'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /** @jsx dom */


var _magicVirtualElement = require('magic-virtual-element');

var _magicVirtualElement2 = _interopRequireDefault(_magicVirtualElement);

var _clickOutside = require('click-outside');

var _clickOutside2 = _interopRequireDefault(_clickOutside);

var _createCmsComponent = require('../../utils/create-cms-component');

var _createCmsComponent2 = _interopRequireDefault(_createCmsComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var unbind = {};
var beforeUnmount = function beforeUnmount(_ref) {
	var props = _ref.props;
	return props.toggle(props.id, true);
};
var handleToggle = function handleToggle(props) {
	return function () {
		return props.toggle(props.id);
	};
};
var afterUpdate = function afterUpdate(_ref2, prevProps) {
	var props = _ref2.props;
	return props.siblingFallback !== prevProps.siblingFallback && props.saveData(props.tree, props.categoryId, props.id, { siblingFallback: props.siblingFallback });
};
var beforeMount = function beforeMount(_ref3) {
	var props = _ref3.props;
	return props.saveData(props.tree, props.categoryId, props.id, { siblingFallback: props.siblingFallback });
};

var afterRender = function afterRender(_ref4, el) {
	var props = _ref4.props;

	if (!props.cmsHidden) {
		return;
	}

	if (unbind[props.id]) {
		unbind[props.id]();
	}

	unbind[props.id] = (0, _clickOutside2.default)(el, function () {
		return props.toggle(props.id, true);
	});
};

var getIcon = function getIcon(props) {
	var iconClosed = props.iconClosed,
	    iconOpen = props.iconOpen,
	    open = props.open,
	    styleClasses = props.styleClasses;

	var icon = open ? iconOpen : iconClosed;

	if (!icon) {
		return (0, _magicVirtualElement2.default)('noscript', null);
	}

	try {
		var parsedIcon = JSON.parse(icon);

		return (0, _magicVirtualElement2.default)(
			'span',
			{ 'class': ['CMS-SubMenuDropdown-current-icon', styleClasses.Sub_Menu_Icon], 'data-style-attr': 'Sub_Menu_Icon' },
			(0, _magicVirtualElement2.default)('i', { 'class': parsedIcon.prefix + ' fa-' + parsedIcon.x.name })
		);
	} catch (err) {
		return (0, _magicVirtualElement2.default)('noscript', null);
	}
};

var render = function render(_ref5) {
	var props = _ref5.props;
	var data = props.data,
	    styleClasses = props.styleClasses,
	    open = props.open,
	    includeParent = props.includeParent,
	    parentLinkPrefix = props.parentLinkPrefix;

	var parentData = _extends({}, data.parent, { isParent: true });
	var items = includeParent ? [parentData].concat(_toConsumableArray(data.children)) : data.children;

	return (0, _createCmsComponent2.default)((0, _magicVirtualElement2.default)(
		'div',
		{ 'class': ['CMS-SubMenuDropdown', { 'CMS-SubMenuDropdown--open': open }, props.class, styleClasses.Sub_Menu], 'data-style-attr': 'Sub_Menu' },
		(0, _magicVirtualElement2.default)(
			'div',
			{ 'class': ['CMS-SubMenuDropdown-current'], onClick: handleToggle(props) },
			(0, _magicVirtualElement2.default)(
				'span',
				{ 'class': ['CMS-SubMenuDropdown-current-name', styleClasses.Sub_Menu_Current], 'data-style-attr': 'Sub_Menu_Current' },
				data.current.categoryName
			),
			getIcon(props)
		),
		open && (0, _magicVirtualElement2.default)(
			'div',
			{ 'class': 'CMS-SubMenuDropdown-options' },
			items.map(function (x) {
				var _classes;

				var name = x.isParent && parentLinkPrefix ? '' + parentLinkPrefix + x.categoryName : x.categoryName;
				var active = x.categoryId === data.current.categoryId;
				var classes = (_classes = {
					'CMS-SubMenuDropdown-item': true,
					'CMS-SubMenuDropdown-item--active': active
				}, _defineProperty(_classes, styleClasses.Sub_Menu_Item, true), _defineProperty(_classes, styleClasses.Sub_Menu_Item_Active, active), _classes);

				return (0, _magicVirtualElement2.default)(
					'div',
					{ key: x.categoryId, 'class': classes, 'data-style-attr': active ? 'Sub_Menu_Item_Active' : 'Sub_Menu_Item' },
					(0, _magicVirtualElement2.default)(
						'a',
						{ 'class': [styleClasses.Sub_Menu_Item_Link], 'data-style-attr': 'Sub_Menu_Item_Link', href: '/' + (x.linkFriendlyName === '/' ? '' : x.linkFriendlyName) },
						name
					)
				);
			})
		)
	), props);
};

exports.default = { afterRender: afterRender, afterUpdate: afterUpdate, beforeUnmount: beforeUnmount, beforeMount: beforeMount, render: render };